module.exports = __webpack_public_path__ + "img/logo-2.9c91c980.png";